import React from 'react';
import PropTypes from 'prop-types';
import { CrownIcon } from './icons';
import './section-header.m.css';

export const SectionHeader = ({ title = 'Select Your Plan', mode }) => (
  <div styleName={`section-header ${mode === 'dark' ? 'dark' : ''}`}>
    <span styleName="crown-badge">
      <CrownIcon />
    </span>
    <h2 styleName="section-header-title" data-test-id="subscription-plan-heading">{title}</h2>
  </div>
);

SectionHeader.propTypes = {
  title: PropTypes.string,
  mode: PropTypes.string
};

